var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.cordova)?_c('random-call-cordova'):(_vm.currentRandomCall)?_c('random-call-session'):(_vm.rating.showing)?_c('random-call-rating'):_c('random-call-lobby')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }